import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Field, Form, Formik } from "formik";
import { FaTimes } from "react-icons/fa";
import validationSchema from "../../../Validation/ValidationSchemas";
import { CircularProgress } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { renameVideo } from "../../../Redux/Actions/VideoLibraryActions";
import { renameUploadedVideo } from "../../../Redux/Actions/UploadVideoAction";
import { renameIntercutVideo } from "../../../Redux/Actions/IntercutVideoActions";
import { renameColumnSet } from "../../../Redux/Actions/VideoLibraryDataTableActions";
import { renameRecordedVideo } from "../../../Redux/Actions/VideoStreamingActions";
const RenameDialog = ({
  successPopUp,
  toggleRenameDialog,
  videoData,
  isLoading,
  fieldToShow,
}) => {
  const dispatch = useDispatch();
  const schoolId = useSelector((state) => state?.loggedInUser?.school?.id);
  const renameVideoInformation = useSelector(
    (state) => state.popupInformation.renamePopup
  );
  const renameAction = useSelector(
    (state) => state.popupInformation.renameAction
  );
  const videoLibraryData = useSelector((state) => state.videoLibraryData);
  const { errorMessage } = useSelector((state) => state?.videoStreamData);

  const handleSubmit = (values) => {
    switch (renameVideoInformation.type) {
      case "rename-recorded-video":
        renameRecordedVideo(dispatch, {
          item: renameVideoInformation.item,
          recording: renameVideoInformation.recording,
          videoName: values.videoName,
          schoolId,
        });
        break;

      case "rename-from-video-library":
        renameVideo(dispatch, {
          videoId: videoData.id,
          videoName: values.videoName,
          schoolId: schoolId,
          loading: true,
          isVideoFromHighlight: renameVideoInformation.isVideoFromHighlight,
          seasonType: renameVideoInformation.seasonType,
          eventType: renameVideoInformation.eventType,
          weekName: renameVideoInformation.weekName,
          offSeasonEventName: renameVideoInformation.offSeasonEventName,
          practiceName: renameVideoInformation.practiceName,
          playlistId: renameVideoInformation?.playlistId,
          otherSeasonEventType: renameVideoInformation.otherSeasonEventType,
          videoId: renameVideoInformation.videoData.id,
          newVideoName: values.videoName,
          isVideoRenamed: true,
          inSeasonData: videoLibraryData.inSeasonData,
          offSeasonData: videoLibraryData.offSeasonData,
          otherSeasonData: videoLibraryData.otherSeasonData,
          seasonName: renameVideoInformation.seasonName,
          selectedVideoPaths: renameVideoInformation?.selectedVideoPaths,
          isVideoFromLibrary: renameVideoInformation?.isVideoFromLibrary,
        });
        break;

      case "rename-video-from-upload-video-page":
        renameUploadedVideo(dispatch, {
          id: videoData.id,
          videoName: values.videoName,
          schoolId,
        });
        break;

      case "rename-video-from-intercut-video-page":
        renameIntercutVideo(dispatch, {
          id: videoData.id,
          videoName: values.videoName,
          schoolId,
          angleName: renameVideoInformation.angleName,
          listName: renameVideoInformation.listName,
        });
        break;

      case "Rename Column Set":
        renameColumnSet(dispatch, {
          id: renameVideoInformation?.id,
          schoolId: renameVideoInformation?.schoolId,
          columnName: values?.videoName,
          apiCall: renameAction,
        });
        break;

      default:
        break;
    }
  };

  return (
    <Dialog
      id="dialogBoxRemove"
      className="dialog-stylee"
      open={successPopUp}
      onClose={toggleRenameDialog}
      maxWidth="sm"
    >
      <DialogTitle>
        <div className="row">
          <div className="col-1 text-right ml-auto">
            <FaTimes
              onClick={(event) => {
                event.stopPropagation();
                toggleRenameDialog(false);
              }}
              className="crossview cp"
            />
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="clear10"></div>
        <div className="row">
          <div className="col-12 text-center">
            <Formik
              validationSchema={validationSchema.videoRenameSchema}
              initialValues={{
                videoName:
                  (videoData &&
                    videoData?.eventMedia?.eventMediaCategory.replace(
                      /\.[^/.]+$/,
                      ""
                    )) ||
                  renameVideoInformation?.item?.fileName ||
                  videoData?.eventMediaCategory ||
                  "",
              }}
              enableReinitialize
              onSubmit={(values) => handleSubmit(values)}
            >
              {(formik) => (
                <Form style={{ minWidth: "300px" }}>
                  <p className="mg-bottom-10 fs-18 semi-bold">Re-Name File</p>
                  <Field
                    name="videoName"
                    className={`form-control w-100 faqtextbox1 ${
                      formik.errors.videoName && "is-invalid"
                    }`}
                  />
                  <div className="errorMsg fs-14 medium">
                    {formik.errors.videoName || errorMessage}
                  </div>
                  <div className="d-flex-center">
                    <button
                      type="submit"
                      className={`mg-top-20 ${
                        formik.isValid ? "saveBtn1" : "saveBtn1 activv"
                      }`}
                      disabled={!formik.isValid}
                    >
                      {isLoading ? (
                        <CircularProgress size="2rem" className="white" />
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>

        <div className="clear10"></div>

        <div className="clear10"></div>
      </DialogContent>
    </Dialog>
  );
};

export default RenameDialog;
